<template>
    <v-expansion-panels accordion flat class="course-session-list" v-if="sortedWorkouts.length">
        <v-expansion-panel
            v-for="workout in sortedWorkouts"
            :key="workout.id"
            class="course-session-list__panel"
        >
            <v-expansion-panel-header class="course-session-list__header px-3">
                <span>
                    <span class="font-weight-bold">{{workout.workoutType.name}}</span>
                    <span class="text--secondary ml-2">{{shortDate(workout.startTime)}}</span>
                </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="course-session-list__content">
                <div v-if="workout.workoutType.description" class="text--secondary mb-2" style="font-size: 0.875rem">
                    {{stripHtml(workout.workoutType.description)}}
                </div>
                <div class="d-flex align-center flex-wrap" style="gap: 12px; font-size: 0.8rem; color: rgba(0,0,0,0.55)">
                    <span class="d-flex align-center">
                        <v-icon x-small color="primary" class="mr-1">mdi-clock-outline</v-icon>
                        {{Date.newFull(workout.startTime).hhmm()}} – {{Date.newFull(workout.endTime).hhmm()}}
                    </span>
                    <span v-if="workout.resources && workout.resources.length" class="d-flex align-center">
                        <v-icon x-small color="primary" class="mr-1">mdi-map-marker-outline</v-icon>
                        <span x-apple-data-detectors="false">
                            <template v-for="(r, index) in visibleResources(workout)">
                                <a v-if="r.position" :key="r.id" href class="primary--text z-no-underline" @click.prevent="$emit('select-resource', r)">{{r.name || r.lastname || r.firstname}}</a>
                                <span v-else :key="r.id">{{r.name || r.lastname || r.firstname}}</span>
                                <span v-if="index < visibleResources(workout).length - 1" :key="'sep-' + r.id">, </span>
                            </template>
                        </span>
                    </span>
                    <span v-if="staffText(workout)" class="d-flex align-center">
                        <v-icon x-small color="primary" class="mr-1">mdi-account-outline</v-icon>
                        {{staffText(workout)}}
                    </span>
                </div>
                <div class="mt-2 text-right">
                    <a href class="primary--text z-no-underline" style="font-size: 0.8rem" @click.prevent="$emit('select-workout', workout)">{{$translate('Read more')}}</a>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import { stripHtml, formatStaffName } from '../util.js'

export default {
    name: 'zoezi-course-session-list',

    props: {
        course: {
            type: Object,
            required: true
        },
        showLastnameForInstructors: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        sortedWorkouts() {
            return [...(this.course?.workouts || [])].sort(
                (a, b) => new Date(a.startTime) - new Date(b.startTime)
            );
        }
    },

    methods: {
        stripHtml,
        shortDate(time) {
            const d = Date.newFull(time);
            const lang = this.$store.state.language;
            const month = lang === 'sv'
                ? this.$translate(d.getMonthName()).toLowerCase().substring(0, 3)
                : this.$translate(d.getMonthName()).substring(0, 3);
            return `${d.getDate()} ${month}`;
        },
        visibleResources(workout) {
            if (!workout.resources || !workout.resources.length) return [];
            const courseRes = (this.course.resources || []).map(r => r.id).sort();
            const wRes = workout.resources.map(r => r.id).sort();
            const same = courseRes.length === wRes.length && courseRes.every((id, i) => String(id) === String(wRes[i]));
            if (same) return [];
            return workout.resources;
        },
        staffText(workout) {
            if (!workout.staffs || !workout.staffs.length) return '';
            return workout.staffs.map(s => formatStaffName(s, this.showLastnameForInstructors)).join(', ');
        }
    }
}
</script>

<style scoped>
.course-session-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.course-session-list__panel {
    border-radius: 14px !important;
    overflow: hidden;
}

.course-session-list ::v-deep .v-expansion-panel {
    background-color: #F5F5F5 !important;
}

.course-session-list__header {
    min-height: 44px !important;
}

.course-session-list__content ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 12px 12px;
}
</style>
